import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../component/auth/Login";
import PageNotFound from "../component/pagenotfound/PageNotFound";
import Register from "../component/auth/Register";
import Otp from "../component/auth/Otp";
// import Home from "../component/home/dashboard/index";
// import Home from "../component/home/Home";

import CompanyProfile from "../component/company-profile/CompanyProfile";
import PostJob from "../component/post-jobs/PostJob";
import Forgotpassword from "../component/forgot-password/Forgotpassword";
import ResetPassword from "../component/resetPassword/ResetPassword";
import ManageJob from "../component/manage-jobs/ManageJob";
import ChangePassword from "../component/change-password/ChangePassword";
import TeramsandConditions from "../component/Terms/TeramsandConditions";
import JobView from "../component/manage-jobs/JobView";
import AllApplicants from "../component/all-applicants/index";
import RecruitmentMetrics from "../component/recruitment-metrics/index";
import Campaigns from "../component/campaigns/index";
import JourneyBuilderScreen from "../component/campaigns/JourneyBuilderScreen";

import Loader from "../Loader/Loader";

// ZOOM
import MeetingList from "../component/meeting/MeetingList";
import ZoomMeeting from "../component/meeting/ZoomMeeting";
import Calender from "../component/calendar/Calendar";
import ReuestTrainer from "../component/requesttrainer/ReuestTrainer";
import PhoneNoAdd from "../component/company-profile/PhoneNoAdd";
import ChatSupport from "../component/chatsupport/ChatSupport";
import SocketContext from "../config/SocketContext";
import { socket } from "../config/socketConnectivity";
import HelperRouter from "./HelperRouter";
import ResumeParser from "../data/ResumeParser";
import InterviewScheduleScreen from "../data/InterviewScheduleScreen";
import ResumeParserNew from "../data/ResumeParserNew";
import AiCompleteScreenViewData from "../data/AiCompleteScreenViewData";
import FeedBack from "../data/FeedBack";
const ProtectedRouter = lazy(() => import("./ProtectedRouter"));

function RouterIndex() {
  return (
    <section>
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <SocketContext.Provider value={socket}>
          <HelperRouter />
          <Routes>
            <Route path="/" element={<Login />}></Route>
            <Route path="/register" element={<Register />}></Route>
            <Route path="/otp" element={<Otp />}></Route>
            <Route path="/forgot-password" element={<Forgotpassword />}></Route>
            <Route path="/reset-password" element={<ResetPassword />}></Route>
            <Route
              path="/terms & conditions"
              element={<TeramsandConditions />}
            ></Route>
            <Route element={<ProtectedRouter></ProtectedRouter>}>
              <Route path="/dashboard" element={<RecruitmentMetrics />}></Route>
              <Route
                path="/company-profile"
                element={<CompanyProfile />}
              ></Route>
              <Route path="/post-jobs" element={<PostJob />}></Route>
              {/* <Route path="/ai-corner" element={<ResumeParser />}></Route> */}
              <Route path="/ai-corner" element={<ResumeParserNew />}></Route>

              <Route
                path="/interview-schedule"
                element={<InterviewScheduleScreen />}
              ></Route>
              <Route
                path="/ai-complete-view-feedback/:id"
                element={<AiCompleteScreenViewData />}
              ></Route>
              <Route path="/manage-jobs" element={<ManageJob />}></Route>
              <Route path="/FeedBack" element={<FeedBack />}></Route>
              <Route
                path="/change-password"
                element={<ChangePassword />}
              ></Route>
              <Route path="/job-View" element={<JobView />}></Route>
              <Route path="/Addnew-Mobile" element={<PhoneNoAdd />}></Route>

              {/* ZOOM */}
              <Route path="/meeting-list" element={<MeetingList />}></Route>
              <Route
                path="/hr_meeting/:token"
                element={<ZoomMeeting />}
              ></Route>
              {/* ZOOM */}
              <Route path="/all-candidates" element={<AllApplicants />}></Route>
              <Route path="/calender" element={<Calender />}></Route>
              <Route
                path="/request-trainers"
                element={<ReuestTrainer />}
              ></Route>
              <Route path="/campaigns" element={<Campaigns />}></Route>
              <Route path="/campaigns/journey-builder" element={<JourneyBuilderScreen />}></Route>
              <Route path="/campaigns/journey-builder/:id" element={<JourneyBuilderScreen />}></Route>
              <Route path="/chat-box" element={<ChatSupport />}></Route>
            </Route>
            {/* <Route path="/offline" element={<Offline />}></Route> */}
            <Route path="*" element={<PageNotFound />}></Route>
          </Routes>
        </SocketContext.Provider>
      </Suspense>
    </section>
  );
}

export default RouterIndex;
